import { Component, Input, OnInit, SimpleChanges } from '@angular/core'
import { DailyLogDiaryType, DailyLogTemplate } from 'src/app/interfaces/daily-log'
import { DailyLogService } from 'src/app/services/daily-log/daily-log.service'

@Component({
  selector: 'app-daily-log-content-cover',
  templateUrl: './daily-log-content-cover.component.html',
  styleUrls: ['./daily-log-content-cover.component.scss'],
})
export class DailyLogContentCoverComponent implements OnInit {
  constructor(private dailyLogService: DailyLogService) {}

  @Input() photoUrl: string | undefined
  @Input() template: DailyLogTemplate | undefined
  @Input() keyword: string | undefined
  @Input() diaryType: DailyLogDiaryType | undefined
  @Input() name: string | undefined
  keywordBackgroundColor: string | undefined
  labelName: string | undefined
  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.hasOwnProperty('diaryType') && changes.diaryType.currentValue) {
      this.keywordBackgroundColor = this.dailyLogService.getDailyLogDiaryTypeData(
        changes.diaryType.currentValue ?? DailyLogDiaryType.ESSAY
      )?.icon.color
    }

    if (changes.hasOwnProperty('name') && changes.name.currentValue) {
      /* 7번째 글자부터 줄바꿈, 10번째 부터 ... 처리 */
      const name = changes.name.currentValue
      const newLineName = name.length > 6 ? name.slice(0, 6) + '\n' + name.slice(6, name.length) : name
      this.labelName = name.length > 9 ? newLineName.slice(0, 9) + '...' : newLineName
    }
  }
}
